import { Injectable } from "@angular/core";
import { AppConstants } from "app/core/app.constants";
import { BaseResponse, GruppiLDAPResponse, User } from "app/core/core.component";
import { environment } from "environments/environment";
import { Observable, Subject } from "rxjs";
import { Headers, Http, ResponseContentType, URLSearchParams } from '@angular/http';
import { UserService } from "./user.service";


@Injectable()
export class GestioneGruppiService {
  private gestioneGruppiComponentStatus = new Subject<User>();
  gestioneGruppiComponentStatus$ = this.gestioneGruppiComponentStatus.asObservable();

  constructor(private http: Http) { }
  changeGruppi(srmToken, user: User, gruppi: string[], loginUser: String, loginPsw: String): Observable<BaseResponse> {
    var url = environment.REST_SERVICE_BASE_URL + "/users/changeGroup";
    url = AppConstants.urlForNoCache(url);
    var headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
    let body = {
      username: user.username,
      gruppi: gruppi,
      loginPsw: loginPsw,
      loginUser: loginUser
    };
    return this.http.post(url, body, { headers: headers }).map((responseData) => responseData.json());
  }
  getUserGruppi(srmToken, user: User): Observable<GruppiLDAPResponse> {
    var url = environment.REST_SERVICE_BASE_URL + "/users/userData/" + user.username + "/getUserGruppi";
    url = AppConstants.urlForNoCache(url);
    var headers = new Headers();
    headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);

    return this.http.get(url, { headers: headers }).map((responseData) => responseData.json());
  }

  geGestioneGruppiComponentStatus(): Observable<User> {
    return this.gestioneGruppiComponentStatus.asObservable();
  }

  openGestioneGruppiComponent(user: User) {
    this.gestioneGruppiComponentStatus.next(user);
  }

  closeGestioneGruppiComponent() {
    this.gestioneGruppiComponentStatus.next();
  }

}


// WEBPACK FOOTER //
// ./src/app/service/gestione-gruppi.service.ts